import React, { useRef } from "react";
import { clsx } from "../../functions.ts";
import './input-base.css';

export enum InputValidity{
  None,
  Valid,
  Invalid,
}

export default function BaseInput (props: {
	value: string,
  placeholder?:string,
  prefix?: string,
  postfix?: string,
  step?: number,
  id:string,
  valid:InputValidity,
  type: "text" | "number",
  hint?: string,
  inputmode?: "text" | "search" | "none" | "tel" | "url" | "email" | "numeric" | "decimal",
  decimals: number,
  onBlur?: () => void,
  onChange: (value: string) => void,
  onKeyDown?: (e: React.KeyboardEvent) => void,
  onClick?: (e: React.MouseEvent)=> void,
  onMouseUp?: (e: React.MouseEvent) => void,
  onMouseDown?: (e: React.MouseEvent) => void,
}){
  const element = useRef(null);

  const placeholder = props.placeholder ? props.placeholder : "";
  const charwidth = 0.6;
  const prefix_length = props.prefix ? props.prefix.length * charwidth: 0;

    let display_value = props.value;
    
    if (props.value && props.type == "number"){
      const decimal_multiplyer =  Math.pow(10, props.decimals || 0);

      const number_value = parseFloat(props.value);
      const decimals = number_value % 1;

      if (props.decimals == 0){
        display_value = Math.round(number_value).toString();
      }else if (decimals.toString().length > props.decimals) {
        display_value = (Math.round(number_value * decimal_multiplyer ) / decimal_multiplyer).toString().replace(/,$/,'').trim();
      }
    }
    
    const value_length = prefix_length + (props.prefix ? 1 : 0) + ((props.value == "" && placeholder ? (placeholder.length || 0) : (display_value || "").toString().length) * charwidth) + 1;

  
      // if (props.decimals == 0 && !v.match(/,$/gm)) {
      //   return;
      // }


  return <div className={clsx("base_input", props.valid == InputValidity.Invalid && "base_input--invalid")}>
        <span className={clsx("input__prefix", display_value && props.prefix && "input__prefix--visible")}>{props.prefix}</span>
        <span className={clsx("input__postfix", display_value && props.postfix && "input__postfix--visible" )} style={{left:value_length+"rem"}}>{props.postfix}</span>
        <input 
          tabIndex={0}
          aria-invalid={!props.valid}
          aria-describedby={props.id+"-hint"}
          aria-labelledby={props.id+"-label"}
          inputMode={props.inputmode}
          ref={element}
          lang="de-DE"
          className={"input__input"} 
          placeholder={placeholder}
          style={{paddingLeft: props.prefix ? 1+prefix_length+"rem" : "1rem"}} 
          id={props.id} 
          type={props.type} 
          step={props.step} 
          value={display_value} 
          onFocus={()=>{
            //element.current.select();
          }}
          onChange={(e: React.KeyboardEvent)=>{
            props.onChange(e.target.value);
          }}
          onClick={(e: React.MouseEvent)=>{
            props.onClick && props.onClick(e);
          }}
          onMouseUp={(e: React.MouseEvent)=>{
            props.onMouseUp && props.onMouseUp(e);
          }}
          onMouseDown={(e: React.MouseEvent)=>{
            props.onMouseDown && props.onMouseDown(e);
          }}
          onBlur={(e) => {
            if(props.onBlur == undefined){return};
            props.onBlur && props.onBlur();
          }}
          onKeyDown={(e)=>{
            if (props.decimals == 0 && (e.key == ',' || e.key == '.')){
              e.preventDefault()
            }
            props.onKeyDown && props.onKeyDown(e);
          }}
        />
        {props.hint && props.valid == InputValidity.Invalid && <div role="alert" id={props.id+"-hint"} className="input__hint">{props.hint}</div>}
    </div>
}